export const MODULE_ID = "VirtoCommerce.Quote";
export const ENABLED_KEY = "Quotes.EnableQuotes";
